import {useReducer} from 'react';

import {HandlerOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {ApplicationCredentialsModel} from '../../../models/api/applicationCredentialsModel';
import {ServerAuthenticationConfig, ServerModel} from '../../../models/api/serverModel';
import {ServerEditorActionTypesEnum} from './serverEditorActions';
import {serverEditorReducer} from './serverEditorReducer';
import {ServerEditorState} from './serverEditorState';

export interface ServerEditorStateActions {
  onUpdateOrigin: HandlerOf<string>;
  onUpdateAuthenticationConfig: HandlerOf<ServerAuthenticationConfig>;
  onUpdateApplicationCredentials: HandlerOf<ApplicationCredentialsModel>;
}

export function useServerEditorState(
  initialServer: ServerModel | undefined,
  initialApplicationCredentials: ApplicationCredentialsModel | undefined,
) {
  const [serverEditorState, dispatch] = useReducer(
    serverEditorReducer,
    ServerEditorState.createInitialState(initialServer, initialApplicationCredentials),
  );

  const onUpdateOrigin = (origin: string) => {
    dispatch({type: ServerEditorActionTypesEnum.UPDATE_ORIGIN, origin});
  };

  const onUpdateAuthenticationConfig = (authenticationConfig: ServerAuthenticationConfig) => {
    dispatch({type: ServerEditorActionTypesEnum.UPDATE_AUTHENTICATION_CONFIG, authenticationConfig});
  };

  const onUpdateApplicationCredentials = (applicationCredentials: ApplicationCredentialsModel) => {
    dispatch({type: ServerEditorActionTypesEnum.UPDATE_APPLICATION_CREDENTIALS, applicationCredentials});
  };

  return {
    serverEditorState,

    onUpdateOrigin,
    onUpdateAuthenticationConfig,
    onUpdateApplicationCredentials,
  };
}
